import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import LazyImage from '../../display/LazyImage'
import formatDriveTime from '../shared/ListingDetails/formatDriveTime'

import kindLabel from './kindLabel'

export type PlaceCardItem = {
  id: string
  page: Pick<GQL_PlacePage, 'name' | 'url' | 'kind'> & {
    heroImage?: Pick<GQL_PhotoImage, 'medium'> | null
  }
  driveMinutes?: number | null
}

const Card = styled.a`
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-01);
  color: var(--ds-text-primary);
  text-decoration: none;

  &:hover,
  &:focus,
  &:visited {
    color: var(--ds-text-primary);
    text-decoration: none;
  }
`

const Photo = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;
  margin-bottom: var(--ds-space-02);
  border-radius: var(--ds-radius-md);
  overflow: hidden;
  background: var(--ds-bg-container-secondary);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Name = styled.span`
  ${typeStyle('-ds-font-body-regular')}
`

const Meta = styled.span`
  ${typeStyle('-ds-font-body-sm-regular')}
  color: var(--ds-text-tertiary);
`

const PlaceCard = ({ item }: { item: PlaceCardItem }) => {
  const { page, driveMinutes } = item
  const meta = [kindLabel(page.kind), formatDriveTime(driveMinutes)]
    .filter(Boolean)
    .join(' · ')

  return (
    <Card href={page.url}>
      <Photo>
        {page.heroImage?.medium && (
          <LazyImage data-src={page.heroImage.medium} alt="" />
        )}
      </Photo>
      <Name>{page.name}</Name>
      <Meta>{meta}</Meta>
    </Card>
  )
}

export default PlaceCard
